import { Shield, Sun, Feather, Repeat, Heart, Sparkles } from "lucide-react";
import { FEATURES } from "../data/site";

const ICONS = {
  uv: Sun,
  polarized: Shield,
  lightweight: Feather,
  flexible: Repeat,
  safe: Heart,
  play: Sparkles,
};

export default function TrustBar() {
  // Render once for desktop visible row; on small screens marquee
  return (
    <section className="relative border-y border-[#2C2C2A]/10 bg-[#FAFAF7] py-5 md:py-7" data-testid="trust-bar">
      <div className="hidden md:flex mx-auto max-w-[1280px] px-10 items-center justify-between gap-6">
        {FEATURES.map((f) => {
          const Icon = ICONS[f.key];
          return (
            <div key={f.key} className="flex items-center gap-2.5 text-[13px] font-medium text-[#2C2C2A]" data-testid={`trust-${f.key}`}>
              <Icon className="w-4 h-4" strokeWidth={1.6} />
              <span>{f.title}</span>
            </div>
          );
        })}
      </div>
      {/* Mobile marquee — features rendered twice for a seamless -50% loop */}
      <div className="md:hidden overflow-hidden">
        <div className="marquee-track">
          {[0, 1].flatMap((copy) =>
            FEATURES.map((f) => {
              const Icon = ICONS[f.key];
              return (
                <div key={`${copy}-${f.key}`} className="flex items-center gap-2 mx-5 text-[13px] font-medium text-[#2C2C2A] whitespace-nowrap">
                  <Icon className="w-4 h-4" strokeWidth={1.6} />
                  <span>{f.title}</span>
                  <span className="text-[#8A8A85] mx-2">·</span>
                </div>
              );
            })
          )}
        </div>
      </div>
    </section>
  );
}
